<div class="container_dialog" fxLayout="column" (close)="dialog.closeAll()">
  <label class="title">Messaggio</label>
  <label class="subtitle">{{ this.message }}</label>
</div>
